import AwardAndCertificateList from "./AwardAndCertificateList";

const CertificateList = ({
}) => {
    return <AwardAndCertificateList/>;
}
export default CertificateList;